import { render, staticRenderFns } from "./SyncStudentList.vue?vue&type=template&id=1ed7a121"
import script from "./SyncStudentList.vue?vue&type=script&lang=js"
export * from "./SyncStudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports